var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from "react";
var DevelopmentContext = createContext(null);
/**
 * Provides context for development modes such as showing gutters, showing todos, etc.
 */
export function useDevelopmentContext() {
    var context = useContext(DevelopmentContext);
    if (context === null) {
        throw new Error('useDevelopmentContext must be used within a DevelopmentContext');
    }
    return context;
}
export function DevelopmentContextProvider(props) {
    var children = props.children;
    var _a = useState(false), showTodos = _a[0], setShowTodos = _a[1];
    var _b = useState(false), showGutters = _b[0], setShowGutters = _b[1];
    var _c = useState(false), absoluteGutters = _c[0], setAbsoluteGutters = _c[1];
    var _d = useState(false), showBreakpoint = _d[0], setShowBreakpoint = _d[1];
    var _e = useState(false), showFooterDivider = _e[0], setShowFooterDivider = _e[1];
    return (_jsx(DevelopmentContext.Provider, __assign({ value: {
            showTodos: showTodos,
            setShowTodos: setShowTodos,
            showGutters: showGutters,
            setShowGutters: setShowGutters,
            absoluteGutters: absoluteGutters,
            setAbsoluteGutters: setAbsoluteGutters,
            showBreakpoint: showBreakpoint,
            setShowBreakpoint: setShowBreakpoint,
            showFooterDivider: showFooterDivider,
            setShowFooterDivider: setShowFooterDivider,
        } }, { children: children })));
}
